module.exports = "/_next/static/images/david-undercoffler-ff16e20d26366e3ad698c3bdbf537bda.jpg";